export default "__VITE_ASSET__D095akZs__"